module.exports = __webpack_public_path__ + "media/KikiD.99c111a3.mp3";